const CONNECTOR_IMG_SRC_MAP = {
    RDBMS_AZURE_SQL_DATAWAREHOUSE: '/resources/img/embrace/azure-sql-data-warehouse-icon.svg',
    RDBMS_GCP_BIGQUERY: '/resources/img/embrace/gcp-big-query-icon.svg',
    RDBMS_REDSHIFT: '/resources/img/embrace/aws-icon.svg',
    RDBMS_SALESFORCE: '/resources/img/embrace/salesforce-ic@3x.png',
    RDBMS_SNOWFLAKE: '/resources/img/embrace/snowflake-icon.svg',
    RDBMS_SERVICE_NOW: '/resources/img/embrace/service-now-ic@3x.png',
    RDBMS_SQLSERVER: '/resources/img/embrace/sql-server-ic@3x.png',
    RDBMS_MARKETO: '/resources/img/embrace/marketo-ic@3x.png',
    RDBMS_ORACLE: '/resources/img/embrace/oracle-ic@3x.png',
    RDBMS_TERADATA: '/resources/img/embrace/teradata-icon.svg',
    RDBMS_SAP_HANA: '/resources/img/embrace/sap-hana-icon.svg',
    RDBMS_PRESTO: '/resources/img/embrace/starburst-icon.svg',
    RDBMS_ORACLE_ADW: '/resources/img/embrace/oracle-adw-icon.svg',
    RDBMS_DATABRICKS: '/resources/img/embrace/databricks-icon.svg',
    RDBMS_DENODO: '/resources/img/embrace/denodo-icon.svg',
    RDBMS_DREMIO: '/resources/img/embrace/dremio-icon.svg',
    RDBMS_TRINO: '/resources/img/embrace/trino-icon.svg',
    RDBMS_PRESTO_JDBC: '/resources/img/embrace/presto-icon.svg',
    RDBMS_DR_SUM: '/resources/img/embrace/drsum-icon.svg',
    RDBMS_POSTGRES: '/resources/img/embrace/postgresql-icon.svg',
    RDBMS_MYSQL: '/resources/img/embrace/mysql-icon.svg',
    RDBMS_SINGLESTORE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/singlestore.svg',
    GOOGLESHEETS: '/resources/img/embrace/google-sheets-icon.svg',
    RDBMS_GENERIC_JDBC: '/resources/img/embrace/java-jdbc-icon.svg',
    SLACK: '/resources/img/embrace/slack-icon.svg',
    SALESFORCE: '/resources/img/embrace/salesforce-icon.svg',
    MSTEAMS: '/resources/img/embrace/ms-teams-icon.svg',
    SERVICENOW: '/resources/img/embrace/service-now.png',
    HUBSPOT: '/resources/img/embrace/hubspot-icon.png',
    GAINSIGHT: '/resources/img/embrace/gainsight.svg',
    ZENDESK: '/resources/img/embrace/zendesk-icon.svg',
    MAILCHIMP: '/resources/img/embrace/mailchimp-icon.svg',
    MSEXCEL: '/resources/img/embrace/ms-excel-icon.svg',
    ZOHO: '/resources/img/embrace/zoho-icon.svg',
    SNOWFLAKE: '/resources/img/embrace/snowflake-icon.svg',
    REDSHIFT: '/resources/img/embrace/aws-icon.svg',
    BIGQUERY: '/resources/img/embrace/gcp-big-query-icon.svg',
    RDBMS_FALCON: 'node_modules/@thoughtspot/radiant-styles/public/img/ThoughtSpot_icon_black.svg',
    RDBMS_AMAZON_RDS_POSTGRESQL: '/resources/img/embrace/amazon-rds-icon.svg',
    RDBMS_AMAZON_AURORA_POSTGRESQL: '/resources/img/embrace/amazon-aurora-icon.svg',
    RDBMS_AMAZON_RDS_MYSQL: '/resources/img/embrace/amazon-rds-icon.svg',
    RDBMS_AMAZON_AURORA_MYSQL: '/resources/img/embrace/amazon-aurora-icon.svg',
    RDBMS_AMAZON_ATHENA: '/resources/img/embrace/amazon-athena-icon.svg',
    WEBEX: '/resources/img/embrace/webex.svg',
    CSV_FILE: '/resources/img/embrace/utilities-upload-csv.svg',
    RDBMS_LOOKER: '/resources/img/embrace/looker-icon.svg',
    DEFAULT_CONNECTION: '/resources/img/embrace/embrace-default-connection.svg',
    RDBMS_LOOKER_ML: '/resources/img/embrace/looker-icon.svg',
    RDBMS_GCP_SQLSERVER: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace/google-cloud-sql.svg',
    RDBMS_GCP_ALLOYDB_POSTGRESQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace/gcp-alloydb-icon.svg',
    RDBMS_GCP_POSTGRESQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace/google-cloud-sql.svg',
    RDBMS_GOOGLE_SHEETS: '/resources/img/embrace/google-sheets-icon.svg',
    RDBMS_GCP_MYSQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace/google-cloud-sql.svg',
    RDBMS_MODE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace/mode-icon.svg',
    RDBMS_FALCON_ONPREM: 'node_modules/@thoughtspot/radiant-styles/public/img/ThoughtSpot_icon_black.svg',
    DATASET: '/img/embrace/dataset-icon.svg',
    RDBMS_CLICKHOUSE: '/img/embrace/clickhouse-icon.svg',
    RDBMS_IOMETE: '/img/embrace/iomete.svg',
};
const CONNECTOR_CATEGORIZATION_IMG_SRC_MAP = {
    RDBMS_AZURE_SQL_DATAWAREHOUSE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/Azure.svg',
    RDBMS_GCP_BIGQUERY: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/BigQuery.svg',
    RDBMS_REDSHIFT: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/Redshift.svg',
    RDBMS_SNOWFLAKE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/Snowflakes.svg',
    RDBMS_SQLSERVER: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/SQLServer.svg',
    RDBMS_ORACLE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/Oracle.svg',
    RDBMS_TERADATA: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/teradata.svg',
    RDBMS_SAP_HANA: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/SAPHANA.svg',
    RDBMS_PRESTO: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/starburst.svg',
    RDBMS_ORACLE_ADW: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/Oracle.svg',
    RDBMS_DATABRICKS: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/databricks.svg',
    RDBMS_DENODO: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/denodo.svg',
    RDBMS_DREMIO: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/dremio.svg',
    RDBMS_TRINO: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/trino.svg',
    RDBMS_PRESTO_JDBC: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/presto.svg',
    RDBMS_DR_SUM: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/DrSum.svg',
    RDBMS_POSTGRES: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/PostgreSQL.svg',
    RDBMS_MYSQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/mySQL.svg',
    RDBMS_SINGLESTORE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/singlestore.svg',
    GOOGLESHEETS: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/Googlesheet.svg',
    RDBMS_GENERIC_JDBC: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/JDBC.svg',
    SNOWFLAKE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/Snowflakes.svg',
    REDSHIFT: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/Redshift.svg',
    BIGQUERY: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/BigQuery.svg',
    RDBMS_FALCON: 'node_modules/@thoughtspot/radiant-styles/public/img/ThoughtSpot_icon_black.svg',
    RDBMS_AMAZON_RDS_POSTGRESQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/AmazonRDS.svg',
    RDBMS_AMAZON_AURORA_POSTGRESQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/AmazonAurora.svg',
    RDBMS_AMAZON_RDS_MYSQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/AmazonRDS.svg',
    RDBMS_AMAZON_AURORA_MYSQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/AmazonAurora.svg',
    RDBMS_AMAZON_ATHENA: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/AmazonAthena.svg',
    CSV_FILE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/csv.svg',
    RDBMS_LOOKER: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/looker.svg',
    DEFAULT_CONNECTION: '/resources/img/embrace/embrace-default-connection.svg',
    RDBMS_LOOKER_ML: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/looker.svg',
    RDBMS_GCP_SQLSERVER: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/GoogleSQL.svg',
    RDBMS_GCP_ALLOYDB_POSTGRESQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/GoogleAlloyDB.svg',
    RDBMS_GCP_POSTGRESQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/GoogleSQL.svg',
    RDBMS_GOOGLE_SHEETS: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/Googlesheet.svg',
    RDBMS_GCP_MYSQL: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/GoogleSQL.svg',
    RDBMS_MODE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/mode.svg',
    RDBMS_FALCON_ONPREM: 'node_modules/@thoughtspot/radiant-styles/public/img/ThoughtSpot_icon_black.svg',
    RDBMS_CLICKHOUSE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/ClickHouse.svg',
    RDBMS_IOMETE: 'node_modules/@thoughtspot/radiant-styles/public/img/embrace-connector-categorization/iomete.svg',
};
export const ResourceURLs = {
    noDataSvgUrl: '/resources/img/svg-icons/embrace-no-data.svg',
    noTrendingSvgUrl: '/resources/img/no-data/no-trending.svg',
};
export const CONNECTOR_DISPLAY_NAME = {
    RDBMS_AZURE_SQL_DATAWAREHOUSE: 'Azure Synapse',
    RDBMS_GCP_BIGQUERY: 'Google BigQuery',
    RDBMS_REDSHIFT: 'Amazon Redshift',
    RDBMS_SALESFORCE: 'Salesforce',
    RDBMS_SNOWFLAKE: 'Snowflake',
    RDBMS_SERVICE_NOW: 'Service Now',
    RDBMS_SQLSERVER: 'SQL Server',
    RDBMS_MARKETO: 'Marketo',
    RDBMS_ORACLE: 'Oracle',
    RDBMS_SAP_HANA: 'SAP HANA',
    RDBMS_TERADATA: 'Teradata',
    RDBMS_PRESTO: 'Starburst',
    RDBMS_ORACLE_ADW: 'Oracle',
    RDBMS_DATABRICKS: 'Databricks',
    RDBMS_DENODO: 'Denodo',
    RDBMS_DREMIO: 'Dremio',
    RDBMS_TRINO: 'Trino',
    RDBMS_PRESTO_JDBC: 'Presto',
    RDBMS_DR_SUM: 'Dr.Sum',
    RDBMS_POSTGRES: 'PostgreSQL',
    RDBMS_MYSQL: 'MySQL',
    RDBMS_SINGLESTORE: 'SingleStore',
    RDBMS_GENERIC_JDBC: 'Generic Jdbc',
    RDBMS_FALCON: 'ThoughtSpot Data Cache',
    RDBMS_AMAZON_RDS_POSTGRESQL: 'Amazon RDS PostgreSQL',
    RDBMS_AMAZON_AURORA_POSTGRESQL: 'Amazon Aurora PostgreSQL',
    RDBMS_AMAZON_RDS_MYSQL: 'Amazon RDS MySQL',
    RDBMS_AMAZON_AURORA_MYSQL: 'Amazon Aurora MySQL',
    RDBMS_AMAZON_ATHENA: 'Amazon Athena',
    RDBMS_GOOGLE_SHEETS: 'Google Sheets',
    GOOGLESHEETS: 'Google Sheets',
    SLACK: 'Slack',
    SNOWFLAKE: 'Snowflake',
    REDSHIFT: 'Redshift',
    BIGQUERY: 'BigQuery',
    SALESFORCE: 'Salesforce',
    MSTEAMS: 'Microsoft Teams',
    SERVICENOW: 'ServiceNow',
    HUBSPOT: 'HubSpot',
    GAINSIGHT: 'Gainsight',
    ZENDESK: 'Zendesk',
    MAILCHIMP: 'Mailchimp',
    MSEXCEL: 'Microsoft Excel',
    WEBEX: 'Webex',
    ZOHO: 'Zoho',
    CSV_FILE: 'CSV File',
    RDBMS_LOOKER: 'Looker',
    RDBMS_LOOKER_ML: 'Looker',
    RDBMS_GCP_SQLSERVER: 'Google Cloud SQL for SQL Server',
    RDBMS_GCP_ALLOYDB_POSTGRESQL: 'Google AlloyDB for PostgreSQL',
    RDBMS_GCP_POSTGRESQL: 'Google Cloud SQL for PostgreSQL',
    RDBMS_GCP_MYSQL: 'Google Cloud SQL for MySQL',
    RDBMS_MODE: 'Mode',
    RDBMS_FALCON_ONPREM: 'Falcon',
    RDBMS_CLICKHOUSE: 'ClickHouse',
    RDBMS_IOMETE: 'Iomete',
};
const QUERYABLE_SOURCES = {
    LOCAL: 'FALCON',
    LIVE: 'LIVE',
};
const EMBRACE_HISTORY = {
    HISTORY_POLLING_TIME: 10 * 1000,
};
const EMBRACE_TABLE_LIST = {
    POLLING_TIME: 10 * 1000,
};
const MAPPING = {
    DATA_MAPPING_FILE_NAME: 'connection.yaml',
};
const AUTH_POLLING_TIME = 500;
const AUTH_TIMEOUT = 300000;
var REQUIRED_OAUTH_FILEDS;
(function (REQUIRED_OAUTH_FILEDS) {
    REQUIRED_OAUTH_FILEDS["CLIENT_ID"] = "client_id";
    REQUIRED_OAUTH_FILEDS["CLIENT_SECRET"] = "client_secret";
})(REQUIRED_OAUTH_FILEDS || (REQUIRED_OAUTH_FILEDS = {}));
const OAUTH_CONFIG_REPONSE_MAP_SIZE = 2;
export const EMBRACE_METADATA_SEARCH_DEBOUNCE_TIME = 300;
export const EMBRACE_TABLE_SELECT_DEBOUNCE_TIME = 500;
export const IS_AUTHENTICATION_DONE = 'isAuthenticationDone';
export const IS_AUTHENTICATION_DONE_FLAG_TTL = 5 * 60 * 1000;
export const REDIRECT_URI = 'redirect_uri';
export const OAUTH_POLLING_INTERVAL = 'oAuthPollingInterval';
export const IS_FORCE_REDIRECT = 'isForceRedirect';
export var CONNECTION_TYPES;
(function (CONNECTION_TYPES) {
    CONNECTION_TYPES["RDBMS_SNOWFLAKE"] = "RDBMS_SNOWFLAKE";
    CONNECTION_TYPES["RDBMS_REDSHIFT"] = "RDBMS_REDSHIFT";
    CONNECTION_TYPES["RDBMS_GCP_BIGQUERY"] = "RDBMS_GCP_BIGQUERY";
    CONNECTION_TYPES["RDBMS_AZURE_SQL_DATAWAREHOUSE"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    CONNECTION_TYPES["RDBMS_SAP_HANA"] = "RDBMS_SAP_HANA";
    CONNECTION_TYPES["RDBMS_TERADATA"] = "RDBMS_TERADATA";
    CONNECTION_TYPES["RDBMS_PRESTO"] = "RDBMS_PRESTO";
    CONNECTION_TYPES["RDBMS_ORACLE_ADW"] = "RDBMS_ORACLE_ADW";
    CONNECTION_TYPES["RDBMS_DENODO"] = "RDBMS_DENODO";
    CONNECTION_TYPES["RDBMS_DREMIO"] = "RDBMS_DREMIO";
    CONNECTION_TYPES["RDBMS_TRINO"] = "RDBMS_TRINO";
    CONNECTION_TYPES["RDBMS_PRESTO_JDBC"] = "RDBMS_PRESTO_JDBC";
    CONNECTION_TYPES["RDBMS_DR_SUM"] = "RDBMS_DR_SUM";
    CONNECTION_TYPES["GOOGLESHEETS"] = "GOOGLESHEETS";
    CONNECTION_TYPES["SLACK"] = "SLACK";
    CONNECTION_TYPES["SALESFORCE"] = "SALESFORCE";
    CONNECTION_TYPES["MSTEAMS"] = "MSTEAMS";
    CONNECTION_TYPES["RDBMS_DATABRICKS"] = "RDBMS_DATABRICKS";
    CONNECTION_TYPES["RDBMS_FALCON"] = "RDBMS_FALCON";
    CONNECTION_TYPES["RDBMS_POSTGRES"] = "RDBMS_POSTGRES";
    CONNECTION_TYPES["RDBMS_SQLSERVER"] = "RDBMS_SQLSERVER";
    CONNECTION_TYPES["RDBMS_MYSQL"] = "RDBMS_MYSQL";
    CONNECTION_TYPES["RDBMS_GENERIC_JDBC"] = "RDBMS_GENERIC_JDBC";
    CONNECTION_TYPES["RDBMS_AMAZON_RDS_POSTGRESQL"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    CONNECTION_TYPES["RDBMS_AMAZON_AURORA_POSTGRESQL"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    CONNECTION_TYPES["RDBMS_AMAZON_RDS_MYSQL"] = "RDBMS_AMAZON_RDS_MYSQL";
    CONNECTION_TYPES["RDBMS_AMAZON_AURORA_MYSQL"] = "RDBMS_AMAZON_AURORA_MYSQL";
    CONNECTION_TYPES["CSV_FILE"] = "CSV_FILE";
    CONNECTION_TYPES["RDBMS_SINGLESTORE"] = "RDBMS_SINGLESTORE";
    CONNECTION_TYPES["RDBMS_LOOKER"] = "RDBMS_LOOKER";
    CONNECTION_TYPES["RDBMS_AMAZON_ATHENA"] = "RDBMS_AMAZON_ATHENA";
    CONNECTION_TYPES["RDBMS_LOOKER_ML"] = "RDBMS_LOOKER_ML";
    CONNECTION_TYPES["RDBMS_GCP_SQLSERVER"] = "RDBMS_GCP_SQLSERVER";
    CONNECTION_TYPES["RDBMS_GCP_ALLOYDB_POSTGRESQL"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    CONNECTION_TYPES["RDBMS_GCP_POSTGRESQL"] = "RDBMS_GCP_POSTGRESQL";
    CONNECTION_TYPES["RDBMS_GOOGLE_SHEETS"] = "RDBMS_GOOGLE_SHEETS";
    CONNECTION_TYPES["RDBMS_GCP_MYSQL"] = "RDBMS_GCP_MYSQL";
    CONNECTION_TYPES["RDBMS_MODE"] = "RDBMS_MODE";
    CONNECTION_TYPES["RDBMS_FALCON_ONPREM"] = "RDBMS_FALCON_ONPREM";
    CONNECTION_TYPES["RDBMS_CLICKHOUSE"] = "RDBMS_CLICKHOUSE";
    CONNECTION_TYPES["RDBMS_IOMETE"] = "RDBMS_IOMETE";
})(CONNECTION_TYPES || (CONNECTION_TYPES = {}));
export var USER_ACTIVE_STATE;
(function (USER_ACTIVE_STATE) {
    USER_ACTIVE_STATE["ACTIVE"] = "ACTIVE";
    USER_ACTIVE_STATE["INACTIVE"] = "INACTIVE";
})(USER_ACTIVE_STATE || (USER_ACTIVE_STATE = {}));
export const MAX_FILE_UPLOAD_SIZE = 1024 * 1024;
export const BYTES_IN_ONE_MB = 1024 * 1024;
export const ZIP_FILE = 'zip';
export const ORACLE_WALLET = 'Oracle Wallet';
export const EMBRACE_STARBURST_OAUTH_FAILURE_TEXT = 'Authentication failed: JWT expired';
export const embraceOauthFailurCodes = [
    12132,
    12133,
    12135,
    12136,
    12137,
    12138,
];
export const getErrorContentSubstitutions = errorResponse => {
    let parameter = errorResponse.data && errorResponse.data.parameter;
    parameter =
        parameter &&
            parameter.map(param => CONNECTOR_DISPLAY_NAME[param]
                ? CONNECTOR_DISPLAY_NAME[param]
                : param);
    return parameter || '';
};
export const CLEAN_RESOURCES_CONNECTION_TYPES = [
    CONNECTION_TYPES.RDBMS_ORACLE_ADW,
];
export var AUTH_TYPE;
(function (AUTH_TYPE) {
    AUTH_TYPE["OAUTH"] = "OAUTH";
    AUTH_TYPE["SERVICE_ACCOUNT"] = "SERVICE_ACCOUNT";
    AUTH_TYPE["IAM"] = "IAM";
    AUTH_TYPE["EXTOAUTH"] = "EXTOAUTH";
    AUTH_TYPE["KEY_PAIR"] = "KEY_PAIR";
    AUTH_TYPE["OAUTH_WITH_PKCE"] = "OAUTH_WITH_PKCE";
    AUTH_TYPE["EXTOAUTH_WITH_PKCE"] = "EXTOAUTH_WITH_PKCE";
    AUTH_TYPE["OAUTH_WITH_PEZ"] = "OAUTH_WITH_PEZ";
    AUTH_TYPE["OAUTH_WITH_SERVICE_PRINCIPAL"] = "OAUTH_WITH_SERVICE_PRINCIPAL";
    AUTH_TYPE["PERSONAL_ACCESS_TOKEN"] = "PERSONAL_ACCESS_TOKEN";
    AUTH_TYPE["OAUTH_CLIENT_CREDENTIALS"] = "OAUTH_CLIENT_CREDENTIALS";
    AUTH_TYPE["OAUTH_CLIENT_CREDENTIALS_WITH_X509"] = "OAUTH_CLIENT_CREDENTIALS_WITH_X509";
})(AUTH_TYPE || (AUTH_TYPE = {}));
export const OAUTH_TYPES = [
    AUTH_TYPE.OAUTH,
    AUTH_TYPE.EXTOAUTH,
    AUTH_TYPE.OAUTH_WITH_PKCE,
    AUTH_TYPE.EXTOAUTH_WITH_PKCE,
    AUTH_TYPE.OAUTH_WITH_PEZ,
];
export const LEARN_MORE_ABOUT_DATA_SECURITY_URL = 'https://www.thoughtspot.com/sites/default/files/pdf/ThoughtSpot-Cloud-Comprehensive-Data-Security-for-Analytics.pdf';
export const embraceConstants = {
    CONNECTOR_IMG_SRC_MAP,
    CONNECTOR_DISPLAY_NAME,
    QUERYABLE_SOURCES,
    EMBRACE_HISTORY,
    MAPPING,
    EMBRACE_TABLE_LIST,
    EMBRACE_METADATA_SEARCH_DEBOUNCE_TIME,
    AUTH_POLLING_TIME,
    AUTH_TIMEOUT,
    REQUIRED_OAUTH_FILEDS,
    OAUTH_CONFIG_REPONSE_MAP_SIZE,
    MAX_FILE_UPLOAD_SIZE,
    ZIP_FILE,
    BYTES_IN_ONE_MB,
    CLEAN_RESOURCES_CONNECTION_TYPES,
    CONNECTION_TYPES,
    getErrorContentSubstitutions,
    CONNECTOR_CATEGORIZATION_IMG_SRC_MAP,
};
export const errorCodes = [12119, 12120, 12331];
//# sourceMappingURL=embrace-constants.js.map